export const BRAND = {
  name: "Invicta Overseas",
  tagline: "Educational Consultancy",
  phone: "+91 93817 17773",
  phoneRaw: "+919381717773",
  whatsapp: "916302261467",
  whatsappDisplay: "+91 63022 61467",
  email: "info@invictaoverseas.com",
  admissionsEmail: "admissions@invictaoverseas.com",
  website: "www.invictaoverseas.com",
  hours: [
    { d: "Monday – Friday", t: "10:00 AM – 6:30 PM" },
    { d: "Saturday", t: "11:00 AM – 5:00 PM" },
    { d: "Sunday", t: "Closed" },
  ],
};

export const STATS = [
  { value: "700+", label: "Partner Universities" },
  { value: "1000+", label: "Students Assisted" },
  { value: "99%", label: "Placement Success" },
  { value: "29+", label: "Countries Covered" },
];

export const DESTINATIONS = [
  { name: "USA", blurb: "Top-ranked universities and unmatched career pathways.", img: "https://images.unsplash.com/photo-1496588152823-86ff7695e68f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxuZXclMjB5b3JrJTIwc2t5bGluZXxlbnwwfHx8fDE3ODI1Njk1MDZ8MA&ixlib=rb-4.1.0&q=85" },
  { name: "United Kingdom", blurb: "World-class education with one-year master's degrees.", img: "https://images.unsplash.com/photo-1486299267070-83823f5448dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxsb25kb24lMjBiaWclMjBiZW58ZW58MHx8fHwxNzgyNTY5NTA2fDA&ixlib=rb-4.1.0&q=85" },
  { name: "Canada", blurb: "Affordable study with strong work & PR opportunities.", img: "https://images.unsplash.com/photo-1569982615761-66697da68502?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx0b3JvbnRvJTIwY24lMjB0b3dlcnxlbnwwfHx8fDE3ODI1Njk1MDZ8MA&ixlib=rb-4.1.0&q=85" },
  { name: "Germany", blurb: "Low-cost, high-quality public universities in Europe.", img: "https://images.unsplash.com/photo-1554072675-66db59dba46f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxCZXJsaW4lMjBCcmFuZGVuYnVyZyUyMEdhdGUlMjBHZXJtYW55fGVufDB8fHx8MTc4MjU2OTg0OXww&ixlib=rb-4.1.0&q=85" },
  { name: "Australia", blurb: "Excellent student experience and post-study work visas.", img: "https://images.unsplash.com/photo-1624138784614-87fd1b6528f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxzeWRuZXklMjBvcGVyYSUyMGhvdXNlfGVufDB8fHx8MTc4MjU2OTUwNnww&ixlib=rb-4.1.0&q=85" },
  { name: "Italy", blurb: "Heritage-rich education with generous scholarships.", img: "https://images.unsplash.com/photo-1704915332184-68202025c9ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxSb21lJTIwQ29sb3NzZXVtJTIwSXRhbHklMjBjaXR5c2NhcGV8ZW58MHx8fHwxNzgyNTY5ODQ5fDA&ixlib=rb-4.1.0&q=85" },
];

export const COUNTRY_OPTIONS = ["USA", "UK", "Canada", "Germany", "Australia", "Italy", "Other"];
export const QUALIFICATIONS = ["10+2 / Intermediate", "Under Graduate (UG)", "Diploma", "Post Graduate", "Other"];
